import { createApp } from 'vue';
import App from './App.vue';
import libs from './libs';
import SchemaForm from './components/SchemaForm/index.vue';
import 'uno.css';
import './styles/index.less';
import store from '@/store';
import router from '@/router';
import sentry from '@/utils/sentry';
import i18n from './locales/i18n';

import('./styles/font.less');

window.$XJCanvas = null;
const app = createApp(App);

app.config.errorHandler = (err, vm, info) => {
  console.error(err);
  console.error(vm);
  console.error(info);
};

sentry(app);

libs(app);
app.component('SchemaForm', SchemaForm);
app.use(store);
app.use(router);
app.use(i18n);
app.mount('#app');
